import './domain/user';

import('./transactions/show').then(() => {
  import('../initial-async-setup');
});
